/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import RegulatoryCharges from "./RegulatoryCharges";

const RegulatoryChargesContainer = () => {
  const regulatoryCharges = [
    {
      charges: "<h3>Transaction Charges</h3>",
      delivery: "NSE: 0.00297% <br/> BSE: 0.00375%",
      intraday: "NSE: 0.00297% <br/> BSE: 0.00375%",
      futures: "NSE: 0.00173% <br/> BSE: 0",
      options: "NSE: 0.03503% <br/> BSE: 0.0325%"
    },
    {
      charges: "<h3>GST</h3>",
      delivery: "18% on brokerage <br />+transaction charges <br />+SEBI Turnover Fees",
      intraday: "18% on brokerage <br />+transaction charges <br />+SEBI Turnover Fees",
      futures: "18% on brokerage <br />+transaction charges <br />+SEBI Turnover Fees",
      options: "18% on brokerage <br />+transaction charges <br />+SEBI Turnover Fees"
    },
    {
      charges: "<h3>Securities Transaction Tax (STT)</h3>",
      delivery: "0.1% <br />on buy and sell",
      intraday: "0.025% <br />on sell transactions",
      futures: "0.02% <br />on future sell side",
      options: "0.125% of the intrinsic value on options that are bought and exercised<br /><br />0.1% Seller - <br/> (on the option premium.)"
    },
    {
      charges: "<h3>SEBI Turnover fees</h3>",
      delivery: "0.0001% <br />of the turnover",
      intraday: "0.0001% <br />of the turnover",
      futures: "0.0001% <br />of the turnover",
      options: "0.0001% <br />of the turnover"
    },
    {
      charges: "<h3>Investors Protection Fund Trust (IPFT)</h3>",
      delivery: "NSE: 0.0001% <br />of the turnover",
      intraday: "NSE: 0.0001% <br />of the turnover",
      futures: "NSE: 0.0001% <br />of the turnover",
      options: "NSE: 0.0005% <br />of the turnover"
    },
    {
      charges: "<h3>Stamp Duty</h3>",
      delivery: "0.015% <br />on the turnover of buy order",
      intraday: "0.003% <br />on the turnover of buy order",
      futures: "0.002% <br />on the turnover of buy order",
      options: "0.003% <br />on the turnover of buy order"
    }
  ];

  return (
    <RegulatoryCharges regulatoryCharges={regulatoryCharges} />
  );
};

export default RegulatoryChargesContainer;
